export interface GetFuelDataRequest {
  plannedDepartureFrom?: string | null;
  plannedDepartureTo?: string | null;

  departureAerodrome?: string;
  arrivalAerodrome?: string;
  fuelUplift?: number;
  flightNo?: string;
  aircraftRegistration?: string;
  legNumber?: number;

  saf?: boolean;
  eligibleForReduction?: boolean;
}
